import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
import {useCallback} from 'react';
import {showAuthDialogWithContinuation} from 'modules/auth/thunks';
import {IUserData} from 'modules/user/models';

export const useShowAuthDialogWithContinuation = () => {
    const dispatch = useAppDispatch();

    return useCallback(
        (onSuccess: (user: IUserData) => void | Promise<void>) => {
            dispatch(showAuthDialogWithContinuation(onSuccess));
        },
        [dispatch],
    );
};
